/**
 * **«اللي حصل النهارده» — وكلُّ سطرٍ فيه يفتح مصدرَه** (قرار شادي ٢٠٢٦-١٠-٢٦).
 *
 * فالسجلُّ يحفظ الكيانَ ومعرّفَه، **وهذه الخريطةُ تقول أين يُفتَح** — رابطٌ من
 * روابط القوقعة المُعلَنة، تحرسه بوابةٌ تقابله بخريطة الوجهات في الواجهة.
 *
 * **وما لا صفحةَ له يفتح عميلَه** — فتعليقٌ أو مرفقٌ معرّفُه معرّفُ نفسه لا
 * كارتِه، **والسطرُ لا يبقى بلا وجهة**: عميلُه هو أقربُ مصدرٍ مؤكَّد.
 */
export const ACTIVITY_LINK = {
    plan_item: "/plan-items/{id}",
    plan: "/plans/{id}",
    card: "/cards/{id}",
    board: "/boards/{id}",
    client: "/clients/{id}",
    report: "/reports/{id}",
    task: "/tasks/{id}",
    meeting: "/meetings/{id}",
};
/**
 * **وكلُّ كيانٍ له صفحةٌ تفتحه — لسجلّ النشاط كاملاً.**
 *
 * فـ«اللي حصل النهارده» يقصد نشاطَ العملاء وحده، فخريطتُه أضيق. أمّا السجلُّ
 * الجنائي فيقرؤه من يحمل قدرتَه بنطاق الشركة، **وسطرٌ عن دورٍ أو موظّفٍ أو
 * طلبِ صلاحيةٍ يفتح صفَّه** — وحارسُ تلك الشاشة يقرّر ما يُرى فيها.
 * والخريطةُ الضيّقةُ جزءٌ من هذه، فلا يختلف رابطٌ واحدٌ بين الاثنين.
 */
export const ENTITY_LINK = {
    ...ACTIVITY_LINK,
    plan_task: "/plan-tasks/{id}",
    user: "/people/{id}",
    role: "/roles/{id}",
    department: "/departments/{id}",
    access_request: "/access-requests/{id}",
    takedown: "/moderation/takedowns/{id}",
    report_exception: "/report-exceptions/{id}",
    company_goal: "/analytics/goals/{id}",
    chat_message: "/chat/{id}",
    release: "/releases/{id}",
};
/** رابطُ الكيان نفسِه — أو لا شيء إن لم تكن له صفحة */
export function entityLink(entity, entityId) {
    const pattern = ENTITY_LINK[entity];
    return pattern !== undefined && entityId !== null ? pattern.replace("{id}", entityId) : null;
}
/** رابطُ السطر — كيانُه إن كانت له صفحة، وإلا عميلُه */
export function activityLink(entity, entityId, clientId) {
    const pattern = ACTIVITY_LINK[entity];
    if (pattern !== undefined && entityId !== null)
        return pattern.replace("{id}", entityId);
    return `/clients/${clientId}`;
}
//# sourceMappingURL=activity.js.map